/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useRef, useState} from 'react';
import {useLocation,matchPath } from 'react-router-dom'
import './layout.css'
import startCase from "lodash/startCase"
import ButtonIcon from "../shared/controls/ButtonIcon";
import {useLoadingState} from "./show-loading-context";
import {Button} from "primereact/button";
import {Menu} from "primereact/menu";
import useApiSource from "../api/source";
import jwt_decode from "jwt-decode";
import {useEmpresa} from "./EmpresaProvider";
import UserNotifications from "../shared/Notifications/UserNotifications";
import useApi from "../api/useApi";
import versionWeb from "../versionWeb";
import {SignalRContext} from "../App";
import {useAuth} from "../Seguridad/AuthProvider";
import logo from "../img/logoIA.png";
import lgoTickets from "../img/logoTickets.png"
import lgoAppMtto from "../img/logoMtto.png"
import constantes from '../catalogos/constantes';
import useSeguridad from '../Seguridad/useSeguridad';

const Header = ({onEmpresaChanged}) => {
    const apiSource = useApiSource();
    const api = useApi()
    const {user:usuarioLogeado, logout} = useAuth();
    const breadCrumbs = getBreadCrumb(useLocation().pathname); //startCase(useLocation().pathname);
    const {datosPath} = useLoadingState();
    const [empresas, setEmpresas] = useState([]);
    const {empresa, actualizarDefault} = useEmpresa();
    const [ultimaVersion, setUltimaVersion] = useState(null);
    const [versionActual, setVersionActual] = useState(null);
    const [visibleVersion, setVisibleVersion] = useState(false)
    const location = useLocation();  
    const seguridad = useSeguridad();
    const permisoIA = seguridad.tieneAcceso(constantes.opciones.permisoIA);
    const permisoAppMtto = seguridad.tieneAcceso(constantes.opciones.permisoAppMtto);
    const permisoTickets = seguridad.tieneAcceso(constantes.opciones.permisoTickets);

     const mostrarAmbiente = !(process.env.REACT_APP_AMBIENTE == null || process.env.REACT_APP_AMBIENTE === 'PROD' || process.env.REACT_APP_AMBIENTE === 'PRODUCCION' || process.env.NODE_ENV === '')

    useEffect(() => {
        obtenerMenu().then();
        setVersionActual(versionWeb);
        obtenerVersion().then();
    }, []);

    const empresaClickHandler = (empresas, empresaId) => {
        const nuevaEmpresa = empresas.find(e => e.id === empresaId);
        onEmpresaChanged(empresaId, nuevaEmpresa);
    }

    const obtenerMenu = async () => {
        const result = await apiSource.obtener('empresas');
        const token = jwt_decode(usuarioLogeado.token);
        setEmpresas(result.map(e => {
            return {
                label: e.nombre,
                id: e.id,
                command: () => empresaClickHandler(result, e.id)
            }
        }));

        const seleccionada = result.find(e => e.id === parseInt(token.empresaId)) ?? {nombre: 'seleccionar Empresa'};
        actualizarDefault(seleccionada)
    }

    const obtenerVersion = async () => {
        const ultimaVersion = await api.get('version', {}, {showLoading: false, showError:false})
        setUltimaVersion(ultimaVersion)
        setVisibleVersion(true)
    }

    const menu = useRef(null);

    function getBreadCrumb(path) {
        path = (decodeURI(path))
        if (path === '/home')
            return []
        return path.split('/')
            .filter(e => e.length > 0 && isNaN(e) === true && e !== 'true' && e !== 'false')
            .map(e => startCase(e).replace('Configuracion', 'Configuración').replace('Facturacion', 'Facturación'));
    }

    const actualizarPagina = ()=>{
        window.location.reload(true);
    }

    SignalRContext.useSignalREffect(
        "nuevaVersion", // Your Event Key
        (version)=>{
            setUltimaVersion(version)
        }
    );
    const hideHeaderRoutes = ["/controlDePatios", "/controlDePatios/nuevo/:id","/controlDePatios/salida/:salida/:id", "/controlDePatios/editar/:salida/:id","relojChecador", "/taller/mantenimiento","/taller/mantenimiento/nuevo_orden/:id?","/taller/mantenimiento/editar_orden/:id"];


    const shouldHideHeader = hideHeaderRoutes.some((route) =>
        matchPath(route, location.pathname)
      );

    return (
        <header className="header" style={{backgroundColor: mostrarAmbiente ? '#e3e4e6': ''}}>
            <div className="aplicacion">
                <h1>
                    {breadCrumbs.map((breadCrumb, i) =>
                        <React.Fragment key={i}>
                            {breadCrumb}
                            {(i < breadCrumbs.length - 1) && <span> / </span>}
                        </React.Fragment>
                    )}
                    {datosPath ? ` / ${datosPath}` : ''}
                </h1>
            </div>
            {mostrarAmbiente &&
                <h4 style={{marginRight:'1em'}} >
                    {'Ambiente '}
                    {process.env.REACT_APP_AMBIENTE}
                </h4>
            }
            {visibleVersion === true && ultimaVersion !== versionActual &&
                <span>
                    <Button label="¡Actualizar Version!" className="p-button-raised p-button-sm p-button-danger" onClick={actualizarPagina}>

                    </Button>
                </span>
            }

             {!shouldHideHeader && !empresa.hidden &&
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <Menu model={empresas} popup ref={menu} id="popup_menu"/>
                    <Button label={empresa?.nombre} onClick={(event) => menu.current.toggle(event)}
                            disabled={empresa.disabled}
                            className="p-button-outlined p-button-sm" aria-controls="popup_menu" aria-haspopup/>

                    {permisoIA &&
                        <button 
                             onClick={() => window.open(process.env.REACT_APP_IA_API_URL, "_blank")}
                            style={{
                                border: "none",
                                background: "transparent",
                                padding: 4,
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: 32,
                                width: 32
                            }}
                            title="Asistente Ximple"
                        >
                            <img 
                                src={logo} 
                                alt="Abrir asistente" 
                                style={{ width: 28, height: 28, objectFit: "contain" }} 
                            />
                        </button>
                     }
                    {permisoTickets &&
                      <button 
                        onClick={() => window.open(process.env.REACT_APP_TICKETS_API_URL, "_blank")}
                        style={{
                            border: "none",
                            background: "transparent",
                            padding: 2,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: 50,
                            width: 50
                        }}
                        title="Sistema Tickets"
                    >
                        <img 
                            src={lgoTickets} 
                            alt="Tickets" 
                            style={{ 
                                width: 42,
                                height: 42,
                                objectFit: "contain",
                                borderRadius: "50%",
                                boxShadow: "0 0 5px rgba(0,0,0,0.25)"
                            }} 
                        />
                    </button>
                     }
                       {permisoAppMtto &&
                        <button 
                            onClick={() => window.open(process.env.REACT_APP_MTTO_API_URL, "_blank")}
                            style={{
                                border: "none",
                                background: "transparent",
                                padding: 2,
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: 54,
                                width: 54
                            }}
                            title="App Mantenimiento"
                        >
                            <img 
                                src={lgoAppMtto} 
                                alt="Mantenimiento" 
                                style={{ 
                                    width: 46,
                                    height: 46,
                                    objectFit: "contain",
                                    borderRadius: "50%",
                                    boxShadow: "0 0 6px rgba(0,0,0,0.25)"
                                }} 
                            />
                        </button>
                     }
                </div>
                 
            }
            <span>{usuarioLogeado.nombre}</span>
            <UserNotifications user={usuarioLogeado}/>
            <a href="/#">
                <ButtonIcon title="Cerrar Sesión" iconName={'FaSignOutAlt'} onClick={logout}/>
            </a>
        </header>
    );
};

export default Header;
